// import { createSelector } from 'reselect';

export const getItem = (state:any) => state.map.item;
export const getItems = (state:any) => state.map.items;
export const getIsFetching = (state:any) => state.map.isFetching;
export const getIsLoading = (state:any) => state.map.isLoading;
export const getStatus = (state:any) => state.map.status;
